// services/contactService.js

import axiosInstance from '../Api/axiosInstance';

// Create a new contact
export const createContact = (contactData) =>
	axiosInstance.post('/contacts', contactData);

// Get a single contact by ID
export const getContactById = (id, companyId) =>
	axiosInstance.get(`/contacts/${id}`, { params: { companyId } });

// Update a contact's details
export const updateContact = (id, contactData, companyId) =>
	axiosInstance.put(`/contacts/${id}`, contactData, { params: { companyId } });

// Delete a contact
export const deleteContact = (id, companyId) =>
	axiosInstance.delete(`/contacts/${id}`, { params: { companyId } });

// Get contacts by list ID with pagination and filters
export const getContactsByListId = (listId, companyId, options = {}) =>
	axiosInstance.get(`/contacts/list/${listId}`, {
		params: { companyId, ...options },
	});

// Get all contacts for a company with pagination and filters
export const getAllContacts = (companyId, options = {}) =>
	axiosInstance.get('/contacts/all', {
		params: { companyId, ...options },
	});

// Bulk import contacts
export const bulkImportContacts = (contacts, listId, companyId) =>
	axiosInstance.post(
		'/contacts/bulk-import',
		{ contacts, listId },
		{
			params: { companyId },
		},
	);

// Update contact status (for email tracking)
export const updateContactStatus = (id, statusData, companyId) =>
	axiosInstance.put(`/contacts/${id}/status`, statusData, {
		params: { companyId },
	});
